import { render, staticRenderFns } from "./Receipts.vue?vue&type=template&id=62f6c0e8&"
import script from "./Receipts.vue?vue&type=script&lang=ts&"
export * from "./Receipts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports